export default __webpack_public_path__ + "static/media/portfolio-hover-169.687e4d1c.jpg";